import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import Icon from '../AppIcon'

export default function PrimaryNavigation({ items, orientation = 'horizontal' }) {
  const location = useLocation()
  const vertical = orientation === 'vertical'
  return <nav aria-label="Primary navigation" className={vertical ? 'flex flex-col gap-1' : 'flex items-center gap-1'}>
    {items?.map(item => {
      const activeChild = item.children?.find(child => location.pathname === child.path)
      const active = location.pathname === item.path || location.pathname.startsWith(item.path + '/') || !!activeChild
      return <div key={item.path} className={vertical && item.path === '/settings' ? 'mt-5 border-t border-border pt-4' : 'relative group'}>
        <Link to={activeChild?.path || item.path} aria-current={active ? 'page' : undefined} title={item.tooltip}
          className={'flex min-h-11 items-center gap-3 rounded-lg px-3 text-[13px] font-medium transition-colors ' +
            (active ? 'bg-foreground text-white' : 'text-foreground hover:bg-muted') +
            (vertical ? ' w-full' : '')}>
          <Icon name={item.icon} size={17} />
          <span className="flex-1">{item.label}</span>
          {vertical && active && <span aria-hidden="true" className="h-1 w-1 rounded-full bg-current" />}
        </Link>
        {item.children && <div className={vertical ? 'ml-5 mt-1 space-y-1 border-l border-border pl-3' : 'absolute left-0 top-full z-50 hidden w-52 rounded-lg border border-border bg-card p-1 shadow-elevation-3 group-hover:block group-focus-within:block'}>
          {item.children.map(child => <Link key={child.path} to={child.path} aria-current={location.pathname === child.path ? 'page' : undefined} className={'flex min-h-11 items-center rounded-lg px-3 text-xs text-foreground ' + (location.pathname === child.path ? 'bg-muted font-semibold' : 'hover:bg-muted')}>{child.label}</Link>)}
        </div>}
      </div>
    })}
  </nav>
}
